import type { OrderWithTimeline } from "../page";

interface Props {
  order: OrderWithTimeline;
}

const infoRows = [
  {
    key: "name" as const,
    label: "الاسم",
    icon: "ri-user-3-line",
    color: "text-amber-400",
    bg: "bg-amber-400/10",
    getValue: (o: OrderWithTimeline) => o.name,
    dir: "rtl" as const,
  },
  {
    key: "phone" as const,
    label: "رقم الجوال",
    icon: "ri-smartphone-line",
    color: "text-green-400",
    bg: "bg-green-400/10",
    getValue: (o: OrderWithTimeline) => o.phone,
    dir: "ltr" as const,
  },
  {
    key: "city" as const,
    label: "المدينة",
    icon: "ri-building-2-line",
    color: "text-sky-400",
    bg: "bg-sky-400/10",
    getValue: (o: OrderWithTimeline) => o.city,
    dir: "rtl" as const,
  },
];

export default function OrderDeliveryInfo({ order }: Props) {
  return (
    <div className="bg-[#141414] border border-white/5 rounded-2xl p-6 flex flex-col">
      <h2 className="text-white font-bold text-sm mb-5 flex items-center gap-2" style={{ fontFamily: "'Cairo', sans-serif" }}>
        <div className="w-7 h-7 flex items-center justify-center bg-amber-400/10 rounded-lg">
          <i className="ri-map-pin-line text-amber-400 text-sm"></i>
        </div>
        معلومات التوصيل
      </h2>

      <div className="flex flex-col gap-3 flex-1">
        {infoRows.map((row) => (
          <div key={row.key} className="flex items-center gap-3">
            <div className={`w-9 h-9 flex items-center justify-center ${row.bg} rounded-xl flex-shrink-0`}>
              <i className={`${row.icon} ${row.color} text-sm`}></i>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-gray-600 text-[11px]" style={{ fontFamily: "'Cairo', sans-serif" }}>{row.label}</p>
              <p className="text-white text-sm font-bold truncate" dir={row.dir} style={{ fontFamily: "'Cairo', sans-serif" }}>
                {row.getValue(order)}
              </p>
            </div>
          </div>
        ))}

        {/* Address */}
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 flex items-center justify-center bg-rose-400/10 rounded-xl flex-shrink-0 mt-0.5">
            <i className="ri-map-pin-2-line text-rose-400 text-sm"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-gray-600 text-[11px]" style={{ fontFamily: "'Cairo', sans-serif" }}>العنوان التفصيلي</p>
            <p className="text-white text-sm font-bold leading-relaxed" style={{ fontFamily: "'Cairo', sans-serif" }}>
              {order.address}
            </p>
          </div>
        </div>

        {/* Notes */}
        {order.notes && order.notes !== "undefined" && (
          <div className="mt-1 flex items-start gap-3 bg-[#1a1a1a] rounded-xl px-3.5 py-3">
            <i className="ri-sticky-note-line text-amber-400/60 text-sm mt-0.5 flex-shrink-0"></i>
            <div>
              <p className="text-gray-600 text-[11px] mb-0.5" style={{ fontFamily: "'Cairo', sans-serif" }}>ملاحظات</p>
              <p className="text-gray-400 text-xs leading-relaxed" style={{ fontFamily: "'Cairo', sans-serif" }}>
                {order.notes}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
